import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import PropTypes from 'prop-types';
import "@whereby.com/browser-sdk/embed"



const EventoWhrebyElement = ({ auth: { user }, roomName, roomKey }) => {

  const [approvedUser, setApprovedUser] = useState(false); // Lista degli utenti approvati
  const [openAssistenza, setOpenAssistenza] = useState(false); // Lista degli utenti approvati

  const [isCameraOn, setIsCameraOn] = useState(false);
const [isMicrophoneOn, setIsMicrophoneOn] = useState(false);

  const wherebyRef = useRef(null);


  // Effettua la connessione WebSocket quando il componente è montato
  useEffect(() => {
    if (user) {
      if(user.ruolo == 'admin'){
        setApprovedUser(true)
      }
    }
  }, [user]);

  useEffect(() => {
    let knockTimeout;
    if (user && user.ruolo !== 'admin' && wherebyRef.current) {
      knockTimeout = setTimeout(() => {
        if (wherebyRef.current) {
          console.log("Invio knock...");
          wherebyRef.current.knock();
        }
      }, 5000); // 5000ms = 5 secondi
    }
    // Pulizia del timeout se il componente viene smontato prima dei 5 secondi
    return () => {
      if (knockTimeout) {
        clearTimeout(knockTimeout);
      }
    };
  }, [wherebyRef.current]); // Esegui quando wherebyRef.current cambia
  

  useEffect(() => {
    if (wherebyRef.current) {
      wherebyRef.current.addEventListener("join", knockAccettato);
    }
    if (wherebyRef.current && user && user.ruolo !== 'admin') {
      const handleLeave = () => {
        window.location.href = '/'; // Reindirizza alla home page
      };
  
      wherebyRef.current.addEventListener('leave', handleLeave);
  
      return () => {
        wherebyRef.current.removeEventListener('leave', handleLeave);
      };
    }

    // Aggiungere l'evento beforeunload per l'admin
    const handleBeforeUnload = (event) => {
      if (user && user.ruolo === 'admin' && wherebyRef.current) {
        wherebyRef.current.endMeeting();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Pulizia dell'evento quando il componente viene smontato
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [wherebyRef.current, user]);






  const toggleCamera = () => {
    if (wherebyRef.current) {
      wherebyRef.current.toggleCamera();
      setIsCameraOn(!isCameraOn)
    }
  };

  const toggleMicrophone = () => {
    if (wherebyRef.current) {
      wherebyRef.current.toggleMicrophone();
      setIsMicrophoneOn(!isMicrophoneOn)
    }
  };

  const toggleScreenShare = () => {
    if (wherebyRef.current) {
      wherebyRef.current.toggleScreenshare();
    }
  };

  const toggleChat = () => {
    if (wherebyRef.current) {
      wherebyRef.current.toggleChat();
    }
  };

  const toggleChiudi = () => {
    window.close();
  };

  const toggleKnock = () => {
    if (wherebyRef.current) {
      console.log(wherebyRef)
      console.log("Invio Knock...");
      wherebyRef.current.knock();
    } else {
      console.error("Whereby embed non è ancora montato.");
    }
  };

  function knockAccettato(event) {
    setApprovedUser(true)
  }

  

  return (
    <div className=''>
      {user ?
       <>
       {user.ruolo == 'admin' ? '' :
       <div className={`intro-approvazione${approvedUser ? " nascondi" : ""}`}>
             <h2 className='nome-utente'>Ciao {user && user.username}</h2>
             <p>Ci siamo quasi! La tua richiesta è stata inviata e stiamo attendendo l'approvazione.</p>
             <p>Nel frattempo, rilassati e preparati a connetterti con gli altri.</p>
             <Spinner />
           </div>
       }
        <div className={`${approvedUser ? "" : "nascondi"}`}>
          <div class={`assistenza_chat${openAssistenza ? " open_assistenza" : ""}`}>
            <div class="ico_question">
              <div class="wrap_question" onClick={() => { setOpenAssistenza(!openAssistenza) }}>{openAssistenza ? "X" : "?"}</div>
              <div class="wrap_question_answer">
                <div class="question_p">
                  <img src="/assets/media/icona_videocamera.png" alt="Icona videocamera" />
                  <span class="title_q">Attiva la tua videocamera</span>
                  <span class="question_par">Premi questo pulsante per accendere o spegnere il video. Se è acceso, gli altri potranno vederti.</span>
                </div>
                <div class="question_p">
                  <img src="/assets/media/icona_microfono.png" alt="Icona microfono" />
                  <span class="title_q">Attiva il microfono</span>
                  <span class="question_par">Premi per attivare o disattivare il microfono. Se è acceso, tutti ti sentiranno parlare.</span>
                </div>
                <div class="question_p">
                  <img src="/assets/media/icona_chat.png" alt="Icona chat" />
                  <span class="title_q">Apri la chat</span>
                  <span class="question_par">Clicca qui per scrivere messaggi agli altri partecipanti durante la chiamata.</span>
                </div>
                <div class="question_p">
                  <img src="/assets/media/icona_esci.png" alt="Icona chat" />
                  <span class="title_q">Chiudi la chiamata</span>
                  <span class="question_par">Clicca qui per chiudere la chiamata.</span>
                </div>
              </div>
            </div>
          </div>
          <div className={`${user && user.ruolo == 'admin' ? "whereby-admin" : "whereby-user"}`}>
            <whereby-embed 
              ref={wherebyRef} 
              room={`https://22-am.whereby.com/${roomName}${user && user.ruolo == 'admin' ? "?roomKey=" + roomKey : ""}`} 
              skipMediaPermissionPrompt="on" 
              logo="off" 
              lang="it" 
              externalId={user._id} 
              displayName={user.username} 
              minimal={`${user && user.ruolo == 'admin' ? "off" : "on"}`} 
              people={`${user && user.ruolo == 'admin' ? "on" : "off"}`} 
              participantCount="off" 
              pipButton="off" 
              chat="on" 
              locking="off" 
              bottomToolbar={`${user && user.ruolo == 'admin' ? "on" : "off"}`} 
              video="off"
              audio="off"
            />
          </div>
          {user.ruolo == 'admin' ? '' :
          <div className="custom_toolbar">
          <div 
            className={`custom_toolbar_button ${isCameraOn ? "active" : "inactive"}`} 
            onClick={toggleCamera}
          >
            <img src="/assets/media/camera-solid.svg" alt="Icona videocamera" />
          </div>
          <div 
            className={`custom_toolbar_button ${isMicrophoneOn ? "active" : "inactive"}`} 
            onClick={toggleMicrophone}
          >
            <img src="/assets/media/microphone-solid.svg" alt="Icona microfono" />
          </div>
          <div className="custom_toolbar_button" onClick={toggleChat}>
            <img src="/assets/media/comments-solid.svg" alt="Icona chat" />
          </div>
          <div className="custom_toolbar_button close" onClick={toggleChiudi}>
            <img src="/assets/media/phone-slash-solid.svg" alt="Icona chiudi" />
          </div>
        </div>
          }
          </div>
          </>
        :
       ''
      }
    </div>
  )

}

EventoWhrebyElement.propTypes = {
  auth: PropTypes.object.isRequired,
  roomName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps)(EventoWhrebyElement);